import { listStoreBuilder } from '@/main/store/pages/list/builder';

import { NAME, CRUMB_LABEL_KEY } from '../constants';
import { apiProvider } from '../api';

export const store = listStoreBuilder({
	name: NAME,
	apiProvider,
	crumbLabel: CRUMB_LABEL_KEY,
	dropdownList: {},
	filter: {
		VINOrRegistrationNumber: null as string | null,
		WithPdi: false as boolean,
	},
	tableSetting: {},
	localState: {
		StatusPrijemky: null,
		tiskDialog: {
			visible: false,
			filter: null as {} | null,
			fetchPdfProvider: null as (() => Promise<any>) | null,
		},
		VINorRegistrationNumber : '',
		withPdi : false,
		pdiOptionSelection : '',
	},
	rowDetail: null,
	extraGetters: {},
	extraActions: {

	},
	extraMutations: {
	},
	props: {
		mode: null,
		filter: {},
		afterRowSelection: () => {},
	},
});
